import ActionViewConstructor, { ActionView } from "csi/action/ActionView";
import Controller from "csi/action/Controller";
import FormData from "csi/action/FormData";
import PostRequest from "csi/comm/PostRequest";
import Tab from "csi/def/Tab";
import { create } from "csi/def/ViewFactory";
import ActionControllerMixin from "csi/wizard/ActionControllerMixin";
import xml from "csi/xml";
import Query from "csi/xml/Query";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";

const CreateLinkedStyleBOMs = declare([Controller, ActionControllerMixin], {
	FIELD_STYLE_BOM_NAME: "StyleBOMName",
	fdStylePage: null,
	fdStyleBOMName: null,

	/**
	 * @override
	 * issue PostRequest to be able to receive return value
	 */
	process() {
		const req = this.m_action.m_request;
		const bomUrl = this.m_urlNode ? this.m_urlNode : this.getContext().cache.getPathNode(this.m_urlParent, "Child:__Parent__").$URL;
		this.setProgress();
		new PostRequest(req.m_module, req.m_operation)
			.addParameter("URL", bomUrl)
			.addParameter("Styles", this.fdStylePage.getSelectedValue())
			.addParameter("Name", this.fdStyleBOMName.getFieldValue(this.FIELD_STYLE_BOM_NAME))
			.post({})
			.then(lang.hitch(this, this._onPublishResponse));
	},

	getActionView(vr): ActionView {
		const ctx = this.getContext();
		const node = ctx.getNode();
		const parent = ctx.getParent();
		const fromApparelBOMRev = this.getCache()
			.getNode
			(this.getParent().__Parent__);
		const nodeURL = node == null ? parent.__Parent__ : node.$URL;
		const parentURL = node != null ? parent.$URL : fromApparelBOMRev.__Parent__;
		const defView = create(null, "Wizard", "ApparelBOM");
		defView.tabs = [
			lang.mixin(new Tab(), { m_idView: "ThemeStyles", m_url: parentURL }),
			lang.mixin(new Tab(), { m_idView: "NameLinkedStyleBOMsForm", m_url: nodeURL }),
		];
		return new ActionViewConstructor(this, defView);
	},

	onNextPage(wizard, currentPage, nextPage, bFinish) {
		const nPage = wizard.getIndexOfPage(nextPage);
		let fd = this.m_formData;
		const bRefresh = false;

		if (nPage === 0) {
			fd = this.fdStylePage = this.fdStylePage || new FormData(this);
			fd.m_bRequireOne = true;
		} else if (nPage === 1) {
			fd = this.fdStyleBOMName = this.fdStyleBOMName || new FormData(this);
		}

		return (fd && !bFinish) ? wizard.setFormDataToPage(nextPage, fd, bRefresh) : null;
	},

	/**
	 * @override
	 * Modify Syle linked view to show only Styles with ApparelBOM active for type;
	 */
	getWizardViewQuery: function(wizard, view, index) {
		if (index == 0) {
			return new Query()
				.Attr2("TDSMap", xml.OP_EQUALS, {
					Path: "Child:ProductType/Child:ProductionConfig",
					Index:"ApparelBOM",
					SValue: true,
				})
				.Attr("Active", xml.OP_EQUALS, true);
		} 
		return null;
	},

});

export = CreateLinkedStyleBOMs;

